import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { UrlConstant } from '../constants/url-constant';
import { AppData } from '../constants/app-data';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(public appData: AppData,
    private dataService: DataService) { }
  
  	ngOnInit(): void {
	//	this.prepareCompanyTypes();
	//	this.prepareIndividualTypes();
	}
	
  public prepareAddressTypes(){
  	this.dataService.sendGetRequest(UrlConstant.apiGetAllAddressTypes).subscribe((data: any)=>{
    //  console.log("prepareAddressTypes:");
    //  console.log(data);
      if("SUCCESS" === data.status){
     // 	console.log("prepareAddressTypes success code");
		this.appData.addressTypes = data.resultMap;
      }
    });
  }
  
  public prepareCompanyTypes(){
  	this.dataService.sendGetRequest(UrlConstant.apiGetAllCompanyTypes).subscribe((data: any)=>{
    //  console.log("prepareCompanyTypes:");
      //console.log(data);
      if("SUCCESS" === data.status){
      //	console.log("prepareCompanyTypes success code");
		this.appData.companyTypes = data.resultMap;
      }
    });
  }
  
  public prepareIndividualTypes(){
  	this.dataService.sendGetRequest(UrlConstant.apiGetAllIndividualTypes).subscribe((data: any)=>{
      //console.log("prepareIndividualTypes::");
     // console.log(data);
      if("SUCCESS" === data.status){
      	//console.log("prepareIndividualTypes success code");
		this.appData.individualTypes = data.resultMap;
      }
    });
  }
  
    public prepareContactTypes(){
  	this.dataService.sendGetRequest(UrlConstant.apiGetAllContactTypes).subscribe((data: any)=>{
      //console.log("prepareContactTypes::");
    //  console.log(data);
      if("SUCCESS" === data.status){
      //	console.log("prepareIndividualTypes success code");
		this.appData.contactTypes = data.resultMap;
      }
    });
  }
  
  public extractEnterpriseIdFromUniqueId(uniqueId){
	  var skipLeftChar=4, skipRightChar=4;
	  if(uniqueId.length <= (skipLeftChar+skipRightChar))
	  	return -1;
	  uniqueId = uniqueId.substr(skipLeftChar);
	  uniqueId = uniqueId.substr(0, uniqueId.length - skipRightChar);
	  return uniqueId;
  }
/**  public isRoleExists(role){
  	console.log('this.appData.allPrivileges.getValue():' + this.appData.allPrivileges.getValue() );
             // Arr.some() returns true if value matchs if false
  	 return this.appData.allPrivileges.getValue().some(roleObj => roleObj.id === role);
  }*/
  
}
